import React, { useEffect, useState } from 'react';
import '../Dashboard.css';
import { IoSearch } from 'react-icons/io5';

const baseURL = process.env.BASE_URL || "";

function SchoolDashboard() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  const adminId = localStorage.getItem('adminId');

  useEffect(() => {
    const fetchSchoolData = async () => {
      try {
        const res = await fetch(`${baseURL}/api/adminroutes/visitors/school`);
        const response = await res.json();
        setData(response);
      } catch (error) {
        console.error('Error fetching school data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (adminId) {
      fetchSchoolData();
    }
  }, [adminId]);

  const filteredData = data.filter(user =>
    user?.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const groupByDate = (users) =>
    users.reduce((acc, user) => {
      if (!acc[user.date]) acc[user.date] = [];
      acc[user.date].push(user);
      return acc;
    }, {});

  const groupedData = groupByDate(filteredData);

  return (
    <div className="dashboard-page">
      <div className="app">
        <h1>SCHOOL USERS</h1>

        <div className="search-bar">
          <input
            type="text"
            className="search-input"
            placeholder="Search by name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button className="search-button">
            <IoSearch />
          </button>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : filteredData.length === 0 ? (
          <p>No users found.</p>
        ) : (
          Object.entries(groupedData).map(([date, users]) => (
            <div key={date} className="table-wrapper">
              <h2 className="date-header">📅 Date: {date}</h2>
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>DOB</th>
                    <th>Gender</th>
                    <th>Class</th>
                    <th>Address</th>
                    <th>Guardian</th>
                    <th>Relation</th>
                    <th>Phone</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{user.name}</td>
                      <td>{new Date(user.DOB).toLocaleDateString()}</td>
                      <td>{user.gender}</td>
                      <td>{user.class}</td>
                      <td>{user.address}</td>
                      <td>{user.guardian}</td>
                      <td>{user.relation}</td>
                      <td>{user.phone}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default SchoolDashboard;
